import AuthHeader from "features/authHeader/AuthHeader";
import VerifyEmailForm from "features/verifyEmail/VerifyEmailForm";
import FullscreenContainer from "features/containers/FullscreenContainer";

const VerifyEmail: React.FC = () => {
  return (
    <FullscreenContainer sx={{ bgcolor: "primary.main" }}>
      <AuthHeader />
      <VerifyEmailForm />
    </FullscreenContainer>
  );
};

export default VerifyEmail;
